export default __webpack_public_path__ + "static/media/bg-profile.9c36abe7.jpg";